module.exports = __webpack_public_path__ + "img/m-banner-qdqhodgn-en-US.1a626482.png";